import styled from 'styled-components'

export const Container = styled.div`
    position: relative;
    cursor: pointer;
    width: 8rem;
    user-select: none;



`;


export const UL = styled.ul`
        width: 100%;
        position: absolute;
        margin: 5px 0 0 0;
        padding: 0;
        list-style: none;
      
        background-color: #40e5a0;
        border-radius: 0.35296625rem;
        box-shadow: 0px 0.235310625rem 0.8824125rem rgba(64, 229, 160, 0.41);

        visibility: ${({ open }) => open ? "visible" : "hidden"};


`;

export const LI = styled.li`
        box-shadow: 0px 0.235310625rem 0.8824125rem rgba(64, 229, 160, 0.41);
        border-radius: 0.35296625rem;
        background-color: #40e5a0;
        padding: 0.4rem;
        text-decoration: underline;
        color: blue;
        &:hover{
            filter: brightness(0.8);
        }

`;





export const Export = styled.button`
  display: flex;
  align-items: center;
  border: none;
  background: #40e5a0;
  border-radius: 0.35296625rem;
  width: 100%;
  padding: 0.994375rem 1.565rem;
  box-shadow: 0px 0.235310625rem 0.8824125rem rgba(64, 229, 160, 0.41);

  &:hover{
    filter: brightness(0.8)

  }

  svg {
    height: 1rem;

  }

  span {
    display: block;
    margin-left: 0.53125rem;
    font-size: 0.7062rem;
    font-family: Sora;


  }

 

`;
